import React from 'react';

const NoDataCertificate = () => {
  return (
    <div
    className='flexCol alignCntr justifyCntr txtCenter pdngTB16 fullVirtualHeight'
    >
      <div
        style={{
          width: '150px',
          height: '150px',
          marginBottom: '16px',
        }}
      >
        <img
          src="/images/icons/NoCertificate.svg"
          alt="No Certificates"
          className='fullH fullWidth'
          style={{
            objectFit: 'contain',
          }}
        />
      </div>
      <span
        style={{
          fontSize: '18px',
          fontWeight: '500',
          marginBottom: '8px',
        }}
      >
        No Certifications has been uploaded
      </span>
      <span
        style={{
          fontSize: '14px',
          color: '#666',
        }}
      >
        Please ask Doctor to upload certificates
      </span>
    </div>
  );
};

export default NoDataCertificate;
